import React from "react";
import styled from "styled-components";

const Heading = styled.h2`
  color: #45a049;
  margin-top: 0;
`;

const Paragraph = styled.p`
  color: #aaaaaa;
  line-height: 1.6;
`;

const CodeBlock = styled.pre`
  background-color: #2f2f2f;
  color: #ffffff;
  padding: 10px;
  border-radius: 5px;
  overflow-x: auto;
`;

const Installation = () => {
  return (
    <div>
      <Heading>Installation</Heading>
      <Paragraph>
        Follow these steps to install the Pingcraft Docs application locally:
      </Paragraph>
      <CodeBlock>{`git clone https://github.com/your-repo/pingcraft-docs.git
cd pingcraft-docs
npm install
npm start`}</CodeBlock>
      <Paragraph>
        Once the development server is running, open
        <code style={{ color: "#45a049" }}> http://localhost:3000 </code>
        in your browser.
      </Paragraph>
    </div>
  );
};

export default Installation;